import { render } from "./SwdDropDown.vue?vue&type=template&id=708a84c0"
import script from "./SwdDropDown.vue?vue&type=script&lang=js"
export * from "./SwdDropDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__